export const HISTORIC_DATA_LABEL = "Historic" as const

export const IMPUTATION_WARNING_THRESHOLD = 0.3

export function getImputationWarningText(fraction: number): string {
  return `${Math.round(fraction * 100)}% of this size split's sales basis is imputed stockout data, so the split may be unreliable.`
}

const npiConfidenceLevels = ["High", "Medium", "Low", "Very Low"] as const

export const confidenceLevels = [HISTORIC_DATA_LABEL, ...npiConfidenceLevels] as const

export type ConfidenceLevel = (typeof confidenceLevels)[number]

export type NpiConfidenceLevel = (typeof npiConfidenceLevels)[number]

export const trustVariantMap: Record<ConfidenceLevel, "green" | "blue" | "yellow" | "gray"> = {
  Historic: "green",
  High: "green",
  Medium: "blue",
  Low: "yellow",
  "Very Low": "gray",
}

export const confidenceConfig: Record<
  ConfidenceLevel,
  { description: string; recommendation: string }
> = {
  Historic: {
    description: "Based on historical sales data for this variant.", // eslint-disable-line @hakio/no-untranslated-terminology
    recommendation: "You can safely use this size split as-is.",
  },
  High: {
    description: "Based on highly relevant historical data.",
    recommendation: "You can safely use this size split as-is.",
  },
  Medium: {
    description: "Based on moderately relevant historical data.",
    recommendation: "Review the size split when placing purchase orders.",
  },
  Low: {
    description: "Based on limited historical data.",
    recommendation: "Consider adjusting the size split manually when placing purchase orders.",
  },
  "Very Low": {
    description:
      "Unable to generate a reliable size split based on historical data. This split is a fallback and should not be used as-is.",
    recommendation: "Create or adjust the size split manually when placing purchase orders.",
  },
}
